import _ from 'lodash';
import { Service } from 'pdk/services';


export class RoleService extends Service {
	// CTOR
    constructor() {
        super();
    }


	// Public Methods
	getRoles() {
        return new Promise((resolve) => {
            resolve([
                {
                    locationGroupRoleTypeID: 1,
                    locationGroupRoleTypeText: "Member"
                },
                {
                    locationGroupRoleTypeID: 2,
                    locationGroupRoleTypeText: "Group Admin"
                }
            ]);
        });
	}
}

export default new RoleService();
